<h1>Privacy</h1>
@if (encryptionActivated()) {
<p>To ensure your privacy your submission is end-to-end-encrypted. This means that the data can only be read by the
    researcher, not even by the system administration or anyone else who might gain access to the system. This is done
    using a asymmetric encryption where the private key required to decrypt your submission is only in possession of the
    researcher.</p>
}
@else {
<p>
    Information about how we protect your privacy is available as part of the
    <a href="assets/information-letter.pdf" target="_blank">information letter belonging to
    this survey</a>.
</p>
}
